<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!--for overlay :loading="get_ay_std_ft_loader" -->
    <!--api- 1  -->
    <v-card class="box" v-if="ay_std_data != null">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Allocate Division</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <!-- <v-row justify="center">
                    <v-col sm="3">
                        <h3>Division Allocation</h3>
                    </v-col>
                </v-row> -->
        <v-row justify="center" dense>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-text-field rounded outlined dense v-model="grno" label="PRN No" type="text"
              hint="For example :: 111"></v-text-field>
          </v-col>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-combobox rounded dense required v-model="current_academic_year" :items="ay_std_data.academic_year_list"
              item-text="Academic Year" label="Academic Year" outlined />
          </v-col>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-combobox rounded dense required v-model="std" :items="ay_std_data.standard_list" item-text="Standard"
              label="Standard" outlined />
          </v-col>
          <v-col sm="2">
            <v-btn class="mt-6 button" @click="getDivisionAllocation" :loading="fetch_btn_load">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <br />
    <!-- api-1 ends -->

    <v-card class="box" v-if="div_off_data != null">
      <v-data-table :headers="headers" :items="div_off_data" sort-by="" class="elevation-1 mytable" dense
        :search="search">
        <template v-slot:top>
          <v-toolbar dense flat color="white" align="center" justify="center">
            <v-toolbar-title>
              {{ grno }}
            </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
          </v-toolbar>
        </template>

        <template v-slot:item.std="{ item }">
          <v-btn class="button pt-1">
            {{ item.std }}
          </v-btn>
        </template>

        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn outlined rounded class="allot-btn" :loading="allocate_btn_load" @click="allocateDivision(item)"
                :disabled="enable_allot_btn" :title="`Allot divison to [${grno}]`">
                <v-icon class="allot-icon">mdi-account-arrow-right-outline</v-icon>
              </v-btn>
            </template>
            <span>Allot </span>
          </v-tooltip>
          <!-- api-4 -->
          <v-icon class="button" :loading="info_btn_load" @click="getDivData(item)"
            title="Get division information">mdi-information-outline</v-icon>
        </template>
        <!-- <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>-->
      </v-data-table>
      <!-- Information Model -->
      <div>
        <v-dialog v-model="dialog" style="margin-left: 10%" fullscreen hide-overlay transition="dialog-top-transition">
          <v-card class="mx-auto box">
            <v-toolbar dense flat class="toolbar">
              <!-- <v-btn icon dark @click="dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn> -->
              <v-toolbar-title>Student Information</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- <v-toolbar-items> -->
              <v-btn small rounded @click="dialog = false">Close</v-btn>
              <!-- </v-toolbar-items> -->
            </v-toolbar>
            <br />
            <v-card-text>
              <template>
                <v-card>
                  <!-- <v-card-title>
                                        Division <span class="font-weight-regular ml-2">{{ this.div_name }}</span> | Year <span class="font-weight-regular ml-2">{{ this.div_year }} </span> | Class Teacher
                                        <span class="font-weight-regular ml-2">{{ this.class_teacher }}</span>
                                        <v-spacer></v-spacer>
                                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                                    </v-card-title> -->
                  <v-data-table :headers="headers1" :items="div_data" class="elevation-1 mytable" dense
                    :search="search"></v-data-table>
                </v-card>
              </template>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    //1
    search: "",
    ay_std_data: null,
    current_academic_year: null,
    // extraBreadcrumbItems: [
     

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    std: null,
    grno: null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    //2
    enable_allot_btn: false,
    div_off_data: null,
    //api-4
    dialog: false,
    div_data: null,
    div_name: null,
    div_year: null,
    class_teacher: null,
    //loader
    get_ay_std_loader: true,
    fetch_btn_load: false,
    allocate_btn_load: false,
    info_btn_load: false,
    headers: [
      { text: "Academic Year", value: "div_off_ay", sortable: true },
      { text: "Standard", value: "div_off_std", sortable: true },
      { text: "Division", value: "div_off_div", sortable: true },
      { text: "# Students", value: "div_off_stud_cnt", sortable: true },
      { text: "Allot", value: "action", sortable: false },
    ],
    headers1: [
      { text: "Student Name", value: "stud_name", sortable: true },
      { text: "Gender", value: "gender", sortable: true },
      { text: "Contact", value: "contact", sortable: true },
      { text: "Roll No", value: "rollno", sortable: true },
      { text: "PRN No", value: "grno", sortable: true },
    ],
  }),
  methods: {
    getDivData(div_off_data_item) {
      //api-4
      this.info_btn_load = true;
      const formData = {
        div_off_id: div_off_data_item.div_off_id,
      };
      axios
        .post("/admission/getDivData", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            this.dialog = true;
            this.div_data = res.data.div_data;
            this.div_name = res.data.div_name;
            this.div_year = res.data.div_year;
            this.class_teacher = res.data.class_teacher;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.info_btn_load = false;
        });
    },
    allocateDivision(div_off_data_item) {
      //api-3
      //alert(this.grno+""+div_off_data_item.div_off_id)
      this.allocate_btn_load = true;
      if (this.grno == null || div_off_data_item.div_off_id == null) {
        this.showSnackbar("#b71c1c", "Something went wrong!!!");
        return;
      }
      const formData = {
        div_off_id: div_off_data_item.div_off_id,
        grno: this.grno,
      };
      axios
        .post("/admission/allocateDivision", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            if (res.data.status == "SUCCESS") {
              this.showSnackbar("#4caf50", res.data.status_reason);
              this.div_off_data = null;
              this.grno = null;
            } else {
              this.showSnackbar("#b71c1c", res.data.status_reason); //error
            }
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.allocate_btn_load = false;
        });
    },
    getDivisionAllocation() {
      //api-2
      this.div_off_data = null;
      this.enable_allot_btn = false;
      this.fetch_btn_load = true;
      const formData = {
        ay: this.current_academic_year,
        std: this.std,
        grno: this.grno,
      };
      axios
        .post("/admission/getDivisionAllocation", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            if (res.data.status == "SUCCESS") {
              if (res.data.learner_div_status == "FOUND") {
                var msg =
                  "Already allocated in " +
                  res.data.learner_div_std +
                  ":" +
                  res.data.learner_div_name +
                  " RollNo:" +
                  res.data.learner_div_rollno;
                this.showSnackbar("#4caf50", msg);
                this.enable_allot_btn = true;
              }
            } else {
              this.showSnackbar("#b71c1c", res.data.status_reason);
            }
            this.div_off_data = res.data.div_off_data;
            if (this.grno == null) {
              this.enable_allot_btn = true;
            }
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.fetch_btn_load = false;
        });
    },
    get_ay_std() {
      //api-1
      this.get_ay_std_ft_loader = true;
      axios
        .post("/feesMaster/get_ay_std_ft")
        .then((res) => {
          if (res.data.msg == "200") {
            this.ay_std_data = res.data.fees_structure_data;
            this.current_academic_year =
              res.data.fees_structure_data.current_academic_year;
            this.std = this.ay_std_data.standard_list[0];
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.get_ay_std_ft_loader = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.get_ay_std();
  },
};
</script>
<style scoped>
.allot-btn,
.allot-icon,
.info-icon {
  transition: 0.3s;
}
.allot-btn:hover .allot-icon {
  color: white;
}
.allot-btn:hover {
  /* background-color: #193a9a !important;
        border-color: #193a9a !important; */
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white;
}

.info-icon:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
  border-radius: 100%;
}
.mytable /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
